import { Communication } from "neo-games";
import { FreeRoundBonusDialog } from "./FreeRoundBonusDialog";
import { DataManager } from "../../../Managers/DataManager";
import { PlayList } from "../../../Components/Sounds/PlayList";
import { ModuleManager } from "../../../Managers/ModuleManager";
import { FreeRoundBonusExtended } from "../Bonuses/FreeRoundBonusExtended";
import { GameApp } from "../../../GameApp";
import { RetentionPanel } from "../../../Utils/RetentionPanel";
import { FreeRoundBonus } from "../Bonuses/FreeRoundBonus";

type FreeRoundsOffersResponse = Communication.Game.FreeRoundsOffersResponse;

var GameModules = Communication.Game.GameModules;

export class FreeRoundBonusIcon {
    private static IconNew: HTMLElement;
    private static IconActive: HTMLElement;

    public static initialize(): void {
        FreeRoundBonusIcon.IconNew = document.getElementById("frbIconNew");
        FreeRoundBonusIcon.IconActive = document.getElementById("frbIconActive");
        FreeRoundBonusIcon.bindEvents();
    }

    // new, active
    public static showIcon(type: string): void {
        FreeRoundBonusIcon.hideAllIcons();
        switch (type) {
            case "new":
                DataManager.showDataElements("helpFRB", "block");
                DataManager.showDataElements("helpFRB_flex", "flex");
                FreeRoundBonusIcon.showElement(FreeRoundBonusIcon.IconNew);
                RetentionPanel.revalidate();
                break;
            case "active":
                DataManager.showDataElements("helpFRB", "block");
                DataManager.showDataElements("helpFRB_flex", "flex");
                FreeRoundBonusIcon.showElement(FreeRoundBonusIcon.IconActive);
                if (FreeRoundBonus.winPayMethod === "cumulative") {
                    if (FreeRoundBonusIcon.IconActive != null) {
                        FreeRoundBonusIcon.IconActive.classList.add("_disabled");
                    }
                }
                RetentionPanel.revalidate();
                break;
        }
        FreeRoundBonusIcon.toggleCumulative();
    }

    /**
     * Toggle cumulative style(s)
     */
    private static toggleCumulative(): void {
        if (FreeRoundBonusExtended.winPayMethod === "cumulative") {
            if (FreeRoundBonusIcon.IconActive != null) {
                FreeRoundBonusIcon.IconActive.classList.add("cumulativeFrb");
            }
        } else {
            if (FreeRoundBonusIcon.IconActive != null) {
                FreeRoundBonusIcon.IconActive.classList.remove("cumulativeFrb");
            }
        }
    }

    private static bindEvents(): void {
        if (FreeRoundBonusIcon.IconNew != null) {
            FreeRoundBonusIcon.IconNew.onclick = FreeRoundBonusIcon.handleIconClick.bind(
                this,
                FreeRoundBonusIcon.onNew,
            );
        }

        if (FreeRoundBonusIcon.IconActive != null) {
            FreeRoundBonusIcon.IconActive.onclick = FreeRoundBonusIcon.handleIconClick.bind(
                this,
                FreeRoundBonusIcon.onActive,
            );
        }
    }

    public static hideAllIcons(): void {
        DataManager.hideDataElements("helpFRB");
        FreeRoundBonusIcon.hideElement(FreeRoundBonusIcon.IconNew);
        FreeRoundBonusIcon.hideElement(FreeRoundBonusIcon.IconActive);
    }

    public static disableActiveIcon(): void {
        if (
            FreeRoundBonusIcon.IconNew != null &&
            !FreeRoundBonusIcon.IconNew.classList.contains("_hidden") &&
            !FreeRoundBonusIcon.IconNew.classList.contains("_disabled")
        ) {
            FreeRoundBonusIcon.IconNew.classList.add("_disabled");
        }
        if (
            FreeRoundBonusIcon.IconActive != null &&
            !FreeRoundBonusIcon.IconActive.classList.contains("_hidden") &&
            !FreeRoundBonusIcon.IconActive.classList.contains("_disabled")
        ) {
            FreeRoundBonusIcon.IconActive.classList.add("_disabled");
        }
    }

    public static enableActiveIcon(): void {
        if (DataManager.Autoplay && (parseFloat(DataManager.AutoplayCount) > 0 || DataManager.AutoplayCount === "∞")) {
            return;
        }
        if (
            FreeRoundBonusIcon.IconNew != null &&
            !FreeRoundBonusIcon.IconNew.classList.contains("_hidden") &&
            FreeRoundBonusIcon.IconNew.classList.contains("_disabled")
        ) {
            FreeRoundBonusIcon.IconNew.classList.remove("_disabled");
        }
        if (
            FreeRoundBonusIcon.IconActive != null &&
            !FreeRoundBonusIcon.IconActive.classList.contains("_hidden") &&
            FreeRoundBonusIcon.IconActive.classList.contains("_disabled")
        ) {
            FreeRoundBonusIcon.IconActive.classList.remove("_disabled");
        }
        RetentionPanel.revalidate();
    }

    private static showElement(element: HTMLElement): void {
        if (element != null) {
            if (element.classList.contains("_disabled")) {
                element.classList.remove("_disabled");
            }
            if (element.classList.contains("_hidden")) {
                element.classList.remove("_hidden");
            }
            if (element.getAttribute("active") != "true") {
                element.setAttribute("active", "true");
            }
        }
    }

    private static hideElement(element: HTMLElement): void {
        if (element != null) {
            if (element.classList.contains("_disabled")) {
                element.classList.remove("_disabled");
            }
            if (!element.classList.contains("_hidden")) {
                element.classList.add("_hidden");
            }
            if (element.getAttribute("active") != "false") {
                element.setAttribute("active", "false");
            }
        }
    }

    private static disableElement(element: HTMLElement): void {
        if (element != null) {
            if (!element.classList.contains("_disabled")) {
                element.classList.add("_disabled");
            }
            if (element.classList.contains("_hidden")) {
                element.classList.remove("_hidden");
            }
            if (element.getAttribute("active") != "true") {
                element.setAttribute("active", "true");
            }
        }
    }

    public static isDisabled(): boolean {
        let isDis: boolean = false;
        if (FreeRoundBonusIcon.IconNew != null && FreeRoundBonusIcon.IconNew.classList.contains("_disabled")) {
            isDis = true;
        }
        if (FreeRoundBonusIcon.IconActive != null && FreeRoundBonusIcon.IconActive.classList.contains("_disabled")) {
            isDis = true;
        }
        return isDis;
    }

    private static handleIconClick(callback: () => void, event: Event): void {
        let element = <Element>event.target;

        if (!FreeRoundBonusIcon.isDisabled() && element != null) {
            element.classList.add("_loading");

            GameApp.gameClient
                .sendFreeRoundsOffersRequest(GameApp.key)
                .then((response: FreeRoundsOffersResponse) => {
                    if (response != null) {
                        if (response.currentOffer != null || response.otherOffers != null) {
                            callback();
                        } else {
                            FreeRoundBonusExtended.expiredFreeRounds();
                        }
                    } else {
                        FreeRoundBonusExtended.expiredFreeRounds();
                    }
                })
                .finally(() => {
                    element.classList.remove("_loading");
                });
        }
    }

    private static onNew(): void {
        if (!FreeRoundBonusIcon.isDisabled()) {
            PlayList.play("SND_Click");
            if (FreeRoundBonusExtended.id != null) {
                FreeRoundBonusDialog.showDialog("new");
            } else {
                if (FreeRoundBonus.otherOfferes.length > 0) {
                    FreeRoundBonusDialog.showDialog("other");
                }
            }
            ModuleManager.disableBase();
        }
    }

    private static onActive(): void {
        if (!FreeRoundBonusIcon.isDisabled() && parseInt(FreeRoundBonusExtended.remainingCount()) > 0) {
            PlayList.play("SND_Click");
            FreeRoundBonusDialog.showDialog("active");
            ModuleManager.disableBase();
            ModuleManager.resetSceneAsOnCollect(GameModules.Base);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Channels/Common/Dialogs/FreeRoundBonusIcon.ts
 **/